import React from 'react';
import './MealsSummary.css'


function MealsSummary() {
    return (
        <section className="summary">
            <h2>Just made, just for you</h2>
            <p>
                Our mission is to create fresh, creative and healthy meals that excite the mind,
                heart and palate. Our menu, farm, local partners and community roots are what make us
                different and with locations all over new york city,
                we are committed to connecting people to real food.
            </p>
            <p>
                We are a family-owned restaurant group, founded in 2010.
            </p>
        </section>

    )
}

export default MealsSummary;